// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */

export var NCS_STORAGE = /*#__PURE__*/function (NCS_STORAGE) {
  NCS_STORAGE["NCS_STORAGE_CLIENT_KEY"] = "ncs-session-step-metrics-storage";
  NCS_STORAGE["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
  NCS_STORAGE["NCS_ACTIVE_SESSIONS"] = "ncsActiveSessions";
  return NCS_STORAGE;
}({});